import { createAsyncThunk } from '@reduxjs/toolkit';
import apiFetch from 'services/apiFetch';
import { updateJurisdictionEndpoint } from 'services/jurisdictionsEndPoints';
import { IJurisdiction } from 'interfaces/jurisdiction.interface';

export const updateJurisdictions = createAsyncThunk(
  'updateJurisdictions',
  async (data: IJurisdiction[]) => {
    try {
      const endpoint = updateJurisdictionEndpoint(data);
      return await apiFetch<Partial<IJurisdiction[]>>(endpoint).then((res) => res?.data || null);
    } catch (error) {
      let message = 'Something went wrong!';
      if (error instanceof Error) message = error.message;
      else {
        if (typeof error === 'object' && error !== null) {
          if ('message' in error) {
            message = String(error.message);
          }
        }
      }
      console.log('updateJurisdiction catch:', message);
      throw Error(message);
    }
  }
);
